import { AuthContext } from "../../auth";
import { useContext } from "react";

function usePlacementsApi() {
  const { placementsApiClient } = useContext(AuthContext);
  return placementsApiClient;
}

export default usePlacementsApi;
